// src/domain/buy/repository.ts

import { Observable } from 'rxjs';

export abstract class ParametrizationRepository {
    abstract getParametrization(uid: string, cid: string | null): Observable<any>;
    abstract setParametrization(uid: string, cid: string | null, data: any): Observable<any>;
    abstract setParametrizationBatch(uid: string, cid: string | null, items: any[]): Observable<any>;
    abstract getParametrizationTypes(uid: string, cid: string | null): Observable<any>;
}

